import {UAParser} from "ua-parser-js";
import {typeUtil} from "./typeUtils";
import {objUtil} from "./objectUtils";
type StringOrUndefined=typeUtil.StringOrUndefined;
const isStrNullOrUndefined=objUtil.isStrNullOrUndefined;
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace deviceUtil {


    export const isMobileExt = (userAgent?: string | null | undefined): boolean => {
        return /Mobile|Mobi|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(userAgent ?? navigator.userAgent);
    };

    export enum DeviceTypeEnum {
        desktop = 'desktop',
        mobile = 'mobile',
        tablet = 'tablet',
        phone = 'phone',
        smarttv = 'smarttv'
    }

    export type DeviceTypeArray = Array<DeviceTypeEnum>

    export class DeviceTypeInfo {


        constructor() {
            const uaParser = new UAParser(window?.navigator?.userAgent);
            const ua = uaParser.getResult();
            this.model = ua.device?.model;
            this.vendor = ua.device?.vendor;
            this.osName = ua.os?.name;
            this.osVersion = ua.os?.version;
            this.type = ua.device?.type;
            if (isStrNullOrUndefined(this.type)) {
                if (isMobileExt()) {
                    this.type = DeviceTypeEnum.mobile;
                } else {
                    this.type = DeviceTypeEnum.desktop;
                }
            }

        }
        type: StringOrUndefined | DeviceTypeEnum;
        model: StringOrUndefined;
        vendor: StringOrUndefined;
        osName: StringOrUndefined;
        osVersion: StringOrUndefined;

        isDesktop():boolean{
            const type=this.type ?? DeviceTypeEnum.mobile;
            const result=DeviceTypeInfo.desktopDevices.some(q=>q === type)
            return result;
        }
        isMobile():boolean{
            const type=this.type ?? DeviceTypeEnum.mobile;
            const result=DeviceTypeInfo.mobileDevices.some(q=>q === type)
            return result;
        }


        public static readonly desktopDevices = [DeviceTypeEnum.desktop, DeviceTypeEnum.tablet, DeviceTypeEnum.smarttv];
        public static readonly mobileDevices = [DeviceTypeEnum.mobile, DeviceTypeEnum.phone];
        public static readonly allDevices = [
            DeviceTypeEnum.mobile,DeviceTypeEnum.phone,
            DeviceTypeEnum.desktop, DeviceTypeEnum.tablet,DeviceTypeEnum.smarttv
        ];


    }

    //export const deviceTypeInfo = new DeviceTypeInfo();

}

